import { useMutation } from "@tanstack/react-query";
import imageCompression from "browser-image-compression";

export function useImageCompressor() {
  return useMutation({
    mutationFn: (file: File) => compressImage(file),
  });
}

const compressionOptions = {
  maxSizeMB: 1,
  useWebWorker: true,
  preserveExif: true,
};
async function compressImage(file: File): Promise<File> {
  try {
    const compressedBlob = await imageCompression(file, compressionOptions);
    return blobToFile(compressedBlob, file.name);
  } catch (error) {
    console.error("Error while compressing image", error);
    return Promise.reject(error);
  }
}

function blobToFile(blob: Blob, fileName: string) {
  return new File([blob], fileName, { type: blob.type });
}
